import React from 'react'

const STEPS = [
  { key: 'pairsCreated', label: 'Pair created' },
  { key: 'firstSessionHeld', label: 'First session held' },
  { key: 'goalSetByReport', label: 'Goal set by report' },
  { key: 'threeOrMoreSessions', label: '3+ sessions in period' },
  { key: 'mutualPrepHalfOrMore', label: 'Mutual prep ≥ 50% of sessions' },
  { key: 'tasksUsed', label: 'Tasks used' },
]

function barColor(pct) {
  if (pct >= 70) return '#639922'
  if (pct >= 50) return '#BA7517'
  return 'rgba(186, 117, 23, 0.55)'
}

export function AdoptionFunnel({ funnel }) {
  const f = funnel || {}
  const baseline = f.pairsCreated || 0
  return (
    <div style={styles.wrap}>
      {STEPS.map((s) => {
        const v = f[s.key] || 0
        const pct = baseline ? Math.round((v / baseline) * 100) : 0
        return (
          <div key={s.key} style={styles.row}>
            <div style={styles.header}>
              <span style={styles.label}>{s.label}</span>
              <span style={styles.num}>{v} <span style={styles.pct}>{pct}%</span></span>
            </div>
            <div style={styles.track}>
              <div style={{ ...styles.fill, width: `${pct}%`, background: barColor(pct) }} />
            </div>
          </div>
        )
      })}
    </div>
  )
}

const styles = {
  wrap: { display: 'flex', flexDirection: 'column', gap: 10 },
  row: { display: 'flex', flexDirection: 'column', gap: 4 },
  header: { display: 'flex', justifyContent: 'space-between', fontSize: 12 },
  label: { color: 'var(--text-primary)' },
  num: { color: 'var(--text-secondary)', fontVariantNumeric: 'tabular-nums' },
  pct: { fontWeight: 600, color: 'var(--text-primary)', marginLeft: 6 },
  track: { height: 8, background: 'var(--border)', borderRadius: 4, overflow: 'hidden' },
  fill: { height: '100%', borderRadius: 4, transition: 'width 0.2s' },
}
